import { fetchMainApi } from '@/api/index'

// Overall notification preferences
export const getNotificationSettings = () => fetchMainApi('GET', '/notification-settings')

export const updateNotificationSettings = (overall) => fetchMainApi('PUT', '/notification-settings', {
  body: JSON.stringify(overall)
})

// Saved load alerts ("Notifications For Specific Loads")
export const getLoadAlerts = () => fetchMainApi('GET', '/load-alerts')

export const createLoadAlert = (data) => fetchMainApi('POST', '/load-alerts', {
  body: JSON.stringify(data)
})

export const updateLoadAlert = (id, data) => fetchMainApi('PUT', `/load-alerts/${id}`, {
  body: JSON.stringify(data)
})

export const deleteLoadAlert = (id) => fetchMainApi('DELETE', `/load-alerts/${id}`)
